import React from 'react'
import {Avatar, makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh'
import DoneIcon from '@material-ui/icons/Done'
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EditIcon from '@material-ui/icons/Edit';


const useStyle = makeStyles(theme => ({
    Done: {backgroundColor: theme.palette.common.success},
    Finished: {backgroundColor: theme.palette.common.success},
    Required: {backgroundColor: theme.palette.common.error},
    Optional: {backgroundColor: theme.palette.common.info},
    Pending: {backgroundColor: theme.palette.common.info},
    Progress: {backgroundColor: theme.palette.common.info},
    Wait: {backgroundColor: theme.palette.action.disabled},
    avatar: {
        width: 30,
        height: 30,
        marginRight: theme.spacing(2)
    }
}))

const icoTab = {
    Required: PriorityHighIcon,
    Done: DoneIcon,
    Optional: PlaylistAddIcon,
    Wait: HourglassFullIcon,
    Finished: CheckCircleIcon,
    Progress: EditIcon
}

export const AvatarStatus = {
    Required: "Required",
    Done: "Done",
    Optional: "Optional",
    Wait: "Wait",
    Finished: "Finished",
    Progress: "Progress"
}

function ExpansionPanelTitleAvatar(
    {
        variant,
        title
    }) {
    const classes = useStyle();

    const Icon = icoTab[variant];
    const className = classes[variant];

    return (<Avatar title={title} className={clsx(className, classes.avatar)}>{Icon && <Icon/>}</Avatar>)

}

ExpansionPanelTitleAvatar.propTypes = {
    variant: PropTypes.oneOf(Object.keys(AvatarStatus)).isRequired,
    title: PropTypes.string
}

export default ExpansionPanelTitleAvatar;